import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExcelService {
  constructor() {}

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    // Create worksheet
    const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([]);

    // Add header row with styling
    this.addStyledHeaders(worksheet, Object.keys(json[0]));

    // Add data rows
    XLSX.utils.sheet_add_json(worksheet, json, { skipHeader: true, origin: 'A2' });

    // Create workbook and write it
    const workbook: XLSX.WorkBook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    // Save the Excel file
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  public exportAsExcelFileWithHeader(json: any[], excelFileName: string, headers: any = {}): void {
    // Transform worksheet with custom headers
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);

    // If headers are provided, rename the first row
    if (Object.keys(headers).length > 0) {
      const headerRow = Object.keys(headers);
      worksheet['!cols'] = headerRow.map(() => ({ width: 20 })); // Adjust column width (optional)
    }

    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private addStyledHeaders(worksheet: XLSX.WorkSheet, headers: string[]): void {
    const headerRow = headers.map((header) => header);

    // Write header row to the sheet
    XLSX.utils.sheet_add_aoa(worksheet, [headerRow], { origin: 'A1' });

    // Apply bold styling to header cells
    headers.forEach((header, colIndex) => {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: colIndex }); // Get cell address for header
      if (!worksheet[cellAddress]) return;

      worksheet[cellAddress].s = {
        font: {
          bold: true,
        },
        alignment: {
          horizontal: 'center',
          vertical: 'center',
        },
      };
    });
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, `${fileName}_export_${new Date().getTime()}${EXCEL_EXTENSION}`);
  }
}
